import { Link } from 'react-router-dom';
import { Container, Content } from '../styles';
import { useAuth } from '../../../context';
import { TypeUser } from '../../../types/enums';

export function MenuOptionLeftCompany() {
  const { user } = useAuth();
  return (
    <Container>
      {[TypeUser.COMPANY, TypeUser.ADM].includes(user?.type) && (
        <>
          <h1 className="Title">Empresa</h1>
          <Content>
            <div className="NavBar">
              <div className="DivOption">
                <Link className="LinkMenuLeft" to="/collaborator">
                  Colaboradores
                </Link>
              </div>
              <div className="DivOption">
                <Link className="LinkMenuLeft" to="/clients">
                  Clientes
                </Link>
              </div>
              <div className="DivOption">
                <Link className="LinkMenuLeft" to="/courts">
                  Varas e Juizados
                </Link>
              </div>
              <div className="DivOption">
                <Link className="LinkMenuLeft" to="/branch">
                  Filiais
                </Link>
              </div>
              <div className="DivOption">
                <Link className="LinkMenuLeft" to="/department">
                  Departamentos
                </Link>
              </div>
              <div className="DivOption">
                <Link className="LinkMenuLeft" to="/profiles">
                  Perfis
                </Link>
              </div>
              {user.type === TypeUser.ADM && (
                <div className="DivOption">
                  <Link className="LinkMenuLeft" to="/plans">
                    Planos
                  </Link>
                </div>
              )}
              {/* <div className="DivOption">
                <Link className="LinkMenuLeft" to="/correspondence">
                  Serviços de correspondência
                </Link>
              </div>
              <div className="DivOption">
                <Link className="LinkMenuLeft" to="/specialties">
                  Especialidades
                </Link>
              </div> */}
            </div>
          </Content>
        </>
      )}
    </Container>
  );
}
